import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const SKIP_SRCS = ['expenselogo', 'sidemenubg', 'sidemenuicon', 'logo', 'favicon', 'loader', 'loading', 'PDF_file_icon'];
const MIN_PX = 28;
const MAX_PX = 260;

const ImageHoverPreview = () => {
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    let hide;

    const skip = (img) => {
      const src = img.src || '';
      if (!src || src.startsWith('data:') || src.includes('.pdf') || src.includes('.svg')) return true;
      if (SKIP_SRCS.some((p) => src.includes(p))) return true;
      const r = img.getBoundingClientRect();
      if (r.width < MIN_PX || r.height < MIN_PX) return true;
      if (r.width > MAX_PX && r.height > MAX_PX) return true;
      return false;
    };

    const over = (e) => {
      const img = e.target.closest('img');
      if (!img || skip(img)) return;
      clearTimeout(hide);
      setPreview({ src: img.src, rect: img.getBoundingClientRect() });
    };

    const out = (e) => {
      if (!e.target.closest('img')) return;
      hide = setTimeout(() => setPreview(null), 80);
    };

    document.addEventListener('mouseover', over);
    document.addEventListener('mouseout', out);
    return () => {
      document.removeEventListener('mouseover', over);
      document.removeEventListener('mouseout', out);
      clearTimeout(hide);
    };
  }, []);

  if (!preview) return null;

  const { src, rect } = preview;
  const SIZE = 210;
  let top = rect.top - SIZE - 10;
  if (top < 6) top = rect.bottom + 10;
  let left = rect.left + rect.width / 2 - SIZE / 2;
  left = Math.max(6, Math.min(left, window.innerWidth - SIZE - 6));

  return createPortal(
    <div
      style={{ position: 'fixed', top, left, zIndex: 999999, pointerEvents: 'none', width: SIZE, height: SIZE }}
      className="rounded-xl overflow-hidden shadow-2xl ring-2 ring-white/80 bg-slate-900 img-hover-preview"
    >
      <img src={src} alt="" className="w-full h-full object-contain" />
    </div>,
    document.body
  );
};

export default ImageHoverPreview;
